import SignLogPro from './SignLogPro_v3';
export default function App() {
  return <SignLogPro />;
}
